import cl from 'classnames'
import styles from './Header.module.scss'
import React from 'react'
import { ChartHeaderProps } from './Header.types'
import { Button, Text1, Text2 } from 'components/shared'
import { IconArrowDown, IconArrowUp } from 'assets'
import { useIsExpanded } from './Header.utils'

const ChartHeaderComponent = (props: ChartHeaderProps) => {
  const {
    className,
    style,
    projectsCount,
    sections,
    total
  } = props

  const {
    isExpanded,
    setIsExpanded
  } = useIsExpanded(props)

  return (
    <div className={cl(styles.chartHeader, className)} style={style}>
      <Button
        preset='icon'
        className={styles.expandButton}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {isExpanded ? <IconArrowUp /> : <IconArrowDown />}
        <Text1>
          {isExpanded ? 'Collapse' : 'Expand'}
        </Text1>
      </Button>

      <div>
      {Array.from(sections.entries()).map(([label, value], index) => (
        <span key={index} className={cl(styles.separated)}>
          {label}
          <Text1 bold style={{ marginLeft: 12 }}>
            {value}
          </Text1>
        </span>
      ))}
      </div>

      <div className={cl(styles.total)} >
        <Text1 bold style={{ fontSize: 16 }}>
          {total}
        </Text1>
        <Text2 style={{ color: styles.secondaryContent }}>
          {projectsCount} projects
        </Text2>
      </div>
    </div>)
}

const ChartHeader = ChartHeaderComponent

export { ChartHeader }
